import { render } from "./B2bPageCmr.vue?vue&type=template&id=6a2d9dc7&scoped=true&lang=pug"
import script from "./B2bPageCmr.vue?vue&type=script&lang=js"
export * from "./B2bPageCmr.vue?vue&type=script&lang=js"

import "./B2bPageCmr.vue?vue&type=style&index=0&id=6a2d9dc7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a2d9dc7"]])

export default __exports__